import { PropsWithChildren } from 'react';

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const InputGroup = ({ children }: PropsWithChildren) => {
  return <div className="my-6">{children}</div>;
};

export default InputGroup;
